import { css } from '@emotion/css';
import React from 'react';
import aquarius from '../../../assets/images/signs/aquarius.svg';
import aries from '../../../assets/images/signs/aries.svg';
import cancer from '../../../assets/images/signs/cancer.svg';
import capricorn from '../../../assets/images/signs/capricorn.svg';
import gemini from '../../../assets/images/signs/gemini.svg';
import leo from '../../../assets/images/signs/leo.svg';
import libra from '../../../assets/images/signs/libra.svg';
import pisces from '../../../assets/images/signs/pisces.svg';
import sagittarius from '../../../assets/images/signs/sagittarius.svg';
import scorpio from '../../../assets/images/signs/scorpio.svg';
import taurus from '../../../assets/images/signs/taurus.svg';
import virgo from '../../../assets/images/signs/virgo.svg';
import { ZodiacSign } from '../../../models/ZodiacSign';

export const ZodiacSignIcon: React.FC<{
  zodiacSign: ZodiacSign;
  ariaLabel?: string;
  ariaHidden?: boolean;
}> = ({ zodiacSign, ariaLabel, ariaHidden }) => {
  let content: string | undefined;
  switch (zodiacSign) {
    case 'Aries':
      content = aries;
      break;
    case 'Taurus':
      content = taurus;
      break;
    case 'Gemini':
      content = gemini;
      break;
    case 'Cancer':
      content = cancer;
      break;
    case 'Leo':
      content = leo;
      break;
    case 'Virgo':
      content = virgo;
      break;
    case 'Libra':
      content = libra;
      break;
    case 'Scorpio':
      content = scorpio;
      break;
    case 'Sagittarius':
      content = sagittarius;
      break;
    case 'Capricorn':
      content = capricorn;
      break;
    case 'Aquarius':
      content = aquarius;
      break;
    case 'Pisces':
      content = pisces;
      break;
    default:
      content = undefined;
  }
  return (
    <span
      className={css`
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        padding: 0;
        margin: 0;
      `}
    >
      <img src={content} id="zodiac-sign" alt="" aria-label={ariaLabel} aria-hidden={ariaHidden} />
    </span>
  );
};
